import React, { useState } from 'react';
import './Contact.scss';

const ContactUs = () => {
  const [isRequestSent, setRequestSent] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isDone, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate an asynchronous request
    setTimeout(() => {
      setLoading(false);
      setDone(true);

      // Show the "Request sent" message for 3 seconds
      setTimeout(() => {
        setRequestSent(true);
        setDone(false);

        // Reset the form
        e.target.reset();

        // Hide the "Request sent" message after 3 seconds
        setTimeout(() => {
          setRequestSent(false);
        }, 3000);
      }, 3000);
    }, 2000);
  };

  return (
    <>
      {!isRequestSent && (
        <div className="page-container">
          <div className="containerwidth">
            <h2>Contact Us</h2>
            <form action="submit_form.php" method="POST" onSubmit={handleSubmit}>
              <label htmlFor="name">Name:</label>
              <input type="text" id="name" name="name" style={{ padding: '20px', marginBottom: '20px' }} required />

              <label htmlFor="email">Email:</label>
              <input type="email" id="email" name="email" style={{ padding: '20px', marginBottom: '20px' }} required />

              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                name="message"
                style={{ height: '170px', marginBottom: '20px', border: 'transparent', borderRadius: '20px' }}
                required
              ></textarea>

              <label htmlFor="telegram">Telegram Link:</label>
              <input type="text" id="telegram" name="telegram" style={{ padding: '20px', marginBottom: '20px' }} required />

              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      )}

      {isRequestSent && (
        <div className="page-container">
          <div className="message-container">
            <div className="message-box">
              <p>Request sent</p>
              <button onClick={() => setRequestSent(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {isLoading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      )}

      {isDone && (
        <div className="done-container">
          <div className="done-checkmark"></div>
        </div>
      )}
    </>
  );
};

export default ContactUs;
